import React from 'react';
import '../styles/aboutus.scss';
import { serverconfigs } from '../constants';
import srLogo from "../assets/sr_logo_rev.png";

class AboutInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        return (
            <div className='about-us'>
                <div className='container'>
                    <h3 className='py-3'>About</h3>
                    <div className='border-bottom'>
                        <p>{serverconfigs.title}</p>
                        <p><img className='about-logo' src={srLogo}/></p>
                        <p>Version v{process.env.REACT_APP_VERSION}</p>
                    </div>

                    <h4 className='py-3'>Mapbox License:</h4>
                    <p>Version v1.13.2 of mapbox-gl-js and earlier are licensed under a BSD-3-Clause license</p>
                    <p>Copyright (c) 2020, Mapbox Redistribution and use in source and binary forms, with or without modification,
                    are permitted provided that the following conditions are met</p>
                    <ul>
                        <li>Redistributions of source code must retain the above copyright notice,
this list of conditions and the following disclaimer.</li>
                        <li>Redistributions in binary form must reproduce the above copyright notice,
                        this list of conditions and the following disclaimer in the documentation
and/or other materials provided with the distribution.</li>
                        <li>Neither the name of Mapbox GL JS nor the names of its contributors
                        may be used to endorse or promote products derived from this software
without specific prior written permission.</li>
                    </ul>
                    <p>THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
                    "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
                    LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
                    A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR
                    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
                    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
                    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
                    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
                    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
                    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.</p>
                    <p>Contains a portion of d3-color <a href='https://github.com/d3/d3-color' target='_blank'>https://github.com/d3/d3-color</a></p>
                    <p>Copyright 2010-2016 Mike Bostock All rights reserved</p>
                    <p>Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:</p>
                    <ul>
                        <li>Redistributions of source code must retain the above copyright notice, this
list of conditions and the following disclaimer.</li>
                        <li>Redistributions in binary form must reproduce the above copyright notice,
                        this list of conditions and the following disclaimer in the documentation
and/or other materials provided with the distribution.</li>
                        <li>Neither the name of the author nor the names of contributors may be used to
                        endorse or promote products derived from this software without specific prior
written permission.</li>
                    </ul>
                    <p>THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                    ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                    WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                    DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                    ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                    (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                    LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
                    ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE</p>
                    <p>Contains code from glfx.js</p>
                    <p>Copyright (C) 2011 by Evan Wallace</p>
                    <p>Permission is hereby granted, free of charge, to any person obtaining a copy
                    of this software and associated documentation files (the "Software"), to deal
                    in the Software without restriction, including without limitation the rights
                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                    copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:</p>
                    <p>The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.</p>
                    <p>THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.</p>
<div className='border-bottom'>         </div>
<h4 className='py-3'>MassGIS License:</h4>
<div>MassGIS: <a href='https://www.mass.gov/info-details/massgis-data-layers' target='_blank'>https://www.mass.gov/info-details/massgis-data-layers</a></div>
<div className='py-2 border-bottom'>         </div>
<h4 className='py-3'>OpenStreetMap Copyright and License:</h4>
<div>OpenStreetMap: <a href='https://www.openstreetmap.org/copyright' target='_blank'>https://www.openstreetmap.org/copyright</a></div>
<div className='py-2 border-bottom'></div>
<h4 className='py-3'>Microsoft Bing License:</h4>
<div>Microsoft: <a href='https://www.microsoft.com/en-us/maps/licensing' target='_blank'>https://www.microsoft.com/en-us/maps/licensing</a></div>
                </div>
            </div>
        );
    }
}

export default AboutInfo;
